import { api, getApiBaseUrl } from './api';
import type { PendingAction } from '../pages/aiAssistant/mockStafflyAssistant';

export interface AiAssistantStatus {
  configured: boolean;
  chatModel: string;
  realtimeModel: string;
}

export interface AiAssistantChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export const aiAssistantApi = {
  status: async (): Promise<AiAssistantStatus> => {
    const response = await api.get<AiAssistantStatus>('/ai-assistant/status');
    return response.data;
  },

  chat: async (
    messages: AiAssistantChatMessage[],
  ): Promise<{ text: string; pendingAction?: PendingAction }> => {
    const response = await api.post<{ text: string; pendingAction?: PendingAction }>('/ai-assistant/chat', {
      messages,
    });
    return response.data;
  },

  executeTool: async (
    name: string,
    args?: Record<string, unknown>,
    confirmed = false,
  ): Promise<Record<string, unknown>> => {
    const response = await api.post('/ai-assistant/tools/execute', {
      name,
      arguments: args ? JSON.stringify(args) : undefined,
      confirmed,
    });
    return typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
  },

  createRealtimeSession: async (sdp: string): Promise<string> => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${getApiBaseUrl()}/ai-assistant/realtime/session`, {
      method: 'POST',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/sdp',
      },
      body: sdp,
    });
    const text = await response.text();
    if (!response.ok) {
      try {
        const err = JSON.parse(text) as { message?: string };
        throw new Error(err.message || text || `Realtime session failed (${response.status})`);
      } catch (e) {
        if (e instanceof Error && e.message !== text) throw e;
        throw new Error(text || `Realtime session failed (${response.status})`);
      }
    }
    return text;
  },
};
